import { useCallback, useState } from 'react'
import { useApiGatewayHost } from '@dhl/api-gateway-provider'
import { getTimeWindows, type CountryCode } from '~/model'
import { useAsyncCall } from '~/hooks/useAsyncCall'

export const useTimeWindows = (countryCode: CountryCode, postalCode: string, useEveningTimeWindows: boolean) => {
  const apiGwHost = useApiGatewayHost() || 'https://api-gw-accept.dhlparcel.nl'
  const [noTimeWindowsFound, setNoTimeWindowsFound] = useState(false)

  const [timeWindows, { isLoading }] = useAsyncCall(
    useCallback(async () => {
      const tws = await getTimeWindows(apiGwHost, countryCode, postalCode, useEveningTimeWindows)
      if (tws.length === 0) {
        setNoTimeWindowsFound(true)
      }
      return tws
    }, [apiGwHost, countryCode, postalCode, useEveningTimeWindows])
  )

  return {
    timeWindows: timeWindows || [],
    isLoading,
    noTimeWindowsFound,
  }
}
